module.exports = __webpack_public_path__ + "img/searchIcon.b3676f70.svg";